// Tiny observable for the campaign message sheet. The push-tap handler
// (RootNavigator) sets the pending message when a campaign push is opened;
// CampaignMessageSheet — mounted once, globally — presents it. Kept out of
// Redux for the same reason voiceApprovalStore is: transient UI, one consumer.
//
// subscribe() emits the current value immediately, which voiceApprovalStore
// does not. It matters here because tapping a campaign push is usually a COLD
// start: the handler runs and sets the pending message before the sheet has
// mounted, so a listener that only hears future changes would show nothing.

export type PendingCampaignMessage = {
  enrollmentId: string;
  stepKey: string;
  campaignKey?: string;
  /** The notification's own copy, so the sheet has something to show while the
   *  content loads rather than an empty spinner. */
  title?: string;
  body?: string;
};

let _pending: PendingCampaignMessage | null = null;
const listeners = new Set<(p: PendingCampaignMessage | null) => void>();

export function showCampaignMessage(p: PendingCampaignMessage): void {
  _pending = p;
  listeners.forEach((l) => l(_pending));
}

export function clearCampaignMessage(): void {
  _pending = null;
  listeners.forEach((l) => l(null));
}

export function getCampaignMessage(): PendingCampaignMessage | null {
  return _pending;
}

export function subscribeCampaignMessage(
  l: (p: PendingCampaignMessage | null) => void,
): () => void {
  listeners.add(l);
  l(_pending);
  return () => {
    listeners.delete(l);
  };
}
